import Head from 'next/head'

import { isToggleEnabled } from 'configs/toggle-feature'
import InfoTerkini from 'app/InfoTerkiniPage/InfoTerkini'
import { getDeviceId } from 'utils/deviceId'

export async function getServerSideProps(ctx) {
  const isRuangGtkEnabled = await isToggleEnabled('ruang-gtk-enabled')
  const isRuangGtkV3Enabled = await isToggleEnabled('ruang-gtk-enabled-v3')

  return {
    props: {
      appDeviceID: getDeviceId(ctx),
      isRuangGtkEnabled,
      isRuangGtkV3Enabled,
    },
  }
}

export const InfoTerkiniPage = ({ isRuangGtkEnabled, isRuangGtkV3Enabled }) => {
  return (
    <>
      <Head>
        <title>Info Terkini - Ruang GTK</title>
      </Head>

      <InfoTerkini
        isRuangGtkEnabled={isRuangGtkEnabled}
        isRuangGtkV3Enabled={isRuangGtkV3Enabled}
      />
    </>
  )
}

InfoTerkiniPage.layoutOpts = {
  hasHeader: false,
}

export default InfoTerkiniPage
